import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getLabelConfig from './labelConfig';

const config = (_: string) => mergeConfig({}, getLabelConfig('data'));

export default {
  [qestIds.assignedMaximumDryDensity.AS_1289_5_4_2.rev2007]: config,
};
